import { h } from 'preact';

import AboutEditor from 'components/editor/pages/about/about';

import s from 'components/editor/pages/about/aboutUniversal.sss';

export default class UniversalAboutEditor extends AboutEditor {
	s = s;

	constructor(props) {
		super(props);
		this.selectRoot = this.selectRoot.bind(this);
	}

	selectRoot() {
		this.props.select('/');
	}

	renderVisualHeader() {
		const pageName = this.getPageName('about', 'About');
		return (
			<div class={this.s.pageHeader}>
				<div class={this.s.breadcrumbs}>{this.getPageName('landing', 'Home')} / <span class={this.s.active}>{pageName}</span></div>
				<div class={this.s.pageTitle} onClick={this.selectRoot}>{pageName}</div>
			</div>
		);
	}
}